module.exports = __webpack_public_path__ + "static/img/invest-health2.e61a8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-health2.jpg
// module id = D28m
// module chunks = 0